import { API_CALL } from '../../../../middleware/api';

export const GET_REPORT_REQ = 'get-report';
export const GET_REPORT_REQ_RESULT = 'get-report/result';
export const GET_REPORT_REQ_ERROR = 'get-report/error';

export const GET_DEVICES_REPORT_REQ = 'get-devices-report';
export const GET_DEVICES_REPORT_REQ_RESULT = `${GET_DEVICES_REPORT_REQ}/result`;
export const GET_DEVICES_REPORT_REQ_ERROR = `${GET_DEVICES_REPORT_REQ}/error`;

export const GET_DEVICES_REPORT_INITIAL_REQ = 'get-devices-report-initial';
export const GET_DEVICES_REPORT_INITIAL_REQ_RESULT = `${GET_DEVICES_REPORT_INITIAL_REQ}/result`;
export const GET_DEVICES_REPORT_INITIAL_REQ_ERROR = `${GET_DEVICES_REPORT_INITIAL_REQ}/error`;

export const GET_DEVICES_REPORT_RECURRING_REQ = 'get-devices-report-recurring';
export const GET_DEVICES_REPORT_RECURRING_REQ_RESULT = `${GET_DEVICES_REPORT_RECURRING_REQ}/result`;
export const GET_DEVICES_REPORT_RECURRING_REQ_ERROR = `${GET_DEVICES_REPORT_RECURRING_REQ}/error`;

export const GET_PROGRAM_STATISTICS = 'get-program-statistics';
export const GET_PROGRAM_STATISTICS_RESULT = `${GET_PROGRAM_STATISTICS}/result`;
export const GET_PROGRAM_STATISTICS_ERROR = `${GET_PROGRAM_STATISTICS}/error`;

export const GET_PATIENTS_STATISTICS = 'get-patients-statistics';
export const GET_PATIENTS_STATISTICS_RESULT = `${GET_PATIENTS_STATISTICS}/result`;
export const GET_PATIENTS_STATISTICS_ERROR = `${GET_PATIENTS_STATISTICS}/error`;

export const GET_ESI_PATIENTS_STATS = 'get-esi-patients-stats';
export const GET_ESI_PATIENTS_STATS_RESULT = `${GET_ESI_PATIENTS_STATS}/result`;
export const GET_ESI_PATIENTS_STATS_ERROR = `${GET_ESI_PATIENTS_STATS}/error`;

export const GET_ENROLLMENTS_METRICS = 'get-enrollments-metrics';
export const GET_ENROLLMENTS_METRICS_RESULT = `${GET_ENROLLMENTS_METRICS}/result`;
export const GET_ENROLLMENTS_METRICS_ERROR = `${GET_ENROLLMENTS_METRICS}/error`;

export const GET_PROGRAM_ANALYTICS = 'get-program-analytics';
export const GET_PROGRAM_ANALYTICS_RESULT = `${GET_PROGRAM_ANALYTICS}/result`;
export const GET_PROGRAM_ANALYTICS_ERROR = `${GET_PROGRAM_ANALYTICS}/error`;

export const actions = {
  getReport: endDate => ({
    [API_CALL]: {
      endpoint: 'portal/report/overview',
      method: 'get',
      params: {
        endDate,
      },
    },
    type: GET_REPORT_REQ,
  }),
  getDevicesReportSummary: (startTimestamp, endTimestamp) => ({
    [API_CALL]: {
      endpoint: 'portal/billing/report/devices/summary',
      method: 'get',
      params: {
        startTimestamp,
        endTimestamp,
        filterBy: 'billing_status:sample,billable',
      },
      responseType: 'blob',

    },
    type: GET_DEVICES_REPORT_REQ,
  }),
  getDevicesReportInitial: (startTimestamp, endTimestamp) => ({
    [API_CALL]: {
      endpoint: 'portal/billing/report/devices/initial',
      method: 'get',
      params: {
        startTimestamp,
        endTimestamp,
        filterBy: 'billing_status:sample,billable',
      },
    },
    type: GET_DEVICES_REPORT_INITIAL_REQ,
  }),
  getDevicesReportRecurring: (startTimestamp, endTimestamp) => ({
    [API_CALL]: {
      endpoint: 'portal/billing/report/devices/recurring',
      method: 'get',
      params: {
        startTimestamp,
        endTimestamp,
      },
    },
    type: GET_DEVICES_REPORT_RECURRING_REQ,
  }),

  getProgramStatistics: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/program_statistics',
      method: 'get',
      params: request,
    },
    type: GET_PROGRAM_STATISTICS,
  }),
  getPatientsStatistics: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/patients_statistics',
      method: 'get',
      params: request,
    },
    type: GET_PATIENTS_STATISTICS,
  }),
  getEnrollmentsMetrics: request => ({
    [API_CALL]: {
      endpoint: 'portal/report/enrollments_metrics',
      method: 'get',
      params: request,
    },
    type: GET_ENROLLMENTS_METRICS,
  }),
  getEsiPatientStats: request => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/report/esi_patients',
      params: request,
    },
    type: GET_ESI_PATIENTS_STATS,
  }),
  getProgramAnalytics: request => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: '/portal/report/program_analytics/download?format=xlsx',
      params: request,
      responseType: 'blob',
    },
    type: GET_PROGRAM_ANALYTICS,
  }),
};
